import { render, staticRenderFns } from "./NewCategoryAdd.vue?vue&type=template&id=aa5d9cb0"
import script from "./NewCategoryAdd.vue?vue&type=script&lang=js"
export * from "./NewCategoryAdd.vue?vue&type=script&lang=js"
import style0 from "./NewCategoryAdd.vue?vue&type=style&index=0&id=aa5d9cb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports